export enum PricePeriodType {
  MONTH = "MONTH",
  YEAR = "YEAR",
}

export interface IImage {
  fileName: string;
  mimeType: string;
  contentBase64: string;
}

export interface IOrderedAdditionalServiceData {
  jointBillServiceId: number;
  jointBillServiceAgreementId: number;
}

export interface IAdditionalService {
  additionalServiceId: number;
  logo: IImage;
  name: string;
  shortDescription?: string;
  description?: string;
  rulesText?: string;
  isNew: boolean;
  isOrdered: boolean;
  orderNumber: number;
  initialPrice?: number;
  firstMonthPrice?: number;
  price: number;
  requiresRulesConfirmation: boolean;
  additionalDocumentUrl?: string;
  jointBillServiceCertificateId?: number;
  onlySingleAllowed: boolean;
  orderedForJointBillServices: number[];
  orderedAdditionalServiceData?: IOrderedAdditionalServiceData[];
}

export interface IDetailedAdditionalService extends IAdditionalService {
  availableForJointBillServices: number[];
}
